import { useEffect } from "react";
import { useAppSelector } from "../store/store";
import { fetchUser } from "../store/features/userSlice";

const useUser = () => {
    const user = useAppSelector(state => state.user);

    useEffect(() => {
        fetchUser({ forceReload: false });
    }, []);
    return user.current.data;
};

export default useUser;